'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dIngredient from "./mealorama.-Ingredient.js";
import * as $j_mealorama$002e$002dNot$002dScaled$002dReason$0024 from "./mealorama.-Not-Scaled-Reason$.js";
import * as $j_mealorama$002e$002dRecipe from "./mealorama.-Recipe.js";
import * as $j_mealorama$002e$002dScaled$002dRecipe from "./mealorama.-Scaled-Recipe.js";
var $p;
function $p_Lmealorama_RecipeScaler$__scaleIngredient__Lmealorama_Ingredient__s_math_BigDecimal__Lmealorama_Ingredient($thiz, ingredient, factor) {
  var x162 = ingredient.hK;
  if (($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() === x162)) {
    return ingredient;
  }
  if ((x162 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var amount = x162.aE;
    var x159 = $p_Lmealorama_RecipeScaler$__normalize__s_math_BigDecimal__s_Option__T2($thiz, amount.HC(factor), ingredient.jb);
    x159.z();
    x159.E();
    var \u03b42$ = x159;
    var newAmount$2 = \u03b42$.z();
    var newUnit$2 = \u03b42$.E();
    var this$1 = ingredient.nl;
    if (this$1.b()) {
      var newRange = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0 = this$1.i();
      var scaledRange = x0.HC(factor);
      if (newUnit$2.b()) {
        var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      } else {
        var x0$1 = newUnit$2.i();
        var $x_1 = $p_Lmealorama_RecipeScaler$__convertTo__s_math_BigDecimal__s_Option__T__s_Option($thiz, scaledRange, ingredient.jb, x0$1);
      }
      var this$2 = $x_1;
      var newRange = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some((this$2.b() ? $p_Lmealorama_RecipeScaler$__round__s_math_BigDecimal__s_math_BigDecimal($thiz, scaledRange) : this$2.i()));
    }
    var $x_4 = ingredient;
    var $x_3_$_lo = $x_4.mS;
    var $x_3_$_hi = $x_4.mT;
    var $x_2 = ingredient;
    return new $j_mealorama$002e$002dIngredient.$c_Lmealorama_Ingredient($x_3_$_lo, $x_3_$_hi, $x_2.nV, $x_2.nW, newUnit$2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(newAmount$2), newRange, ingredient.jZ, ingredient.ni, ingredient.hl, ingredient.oB, ingredient.nj, ingredient.nk);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x162);
}
export { $p_Lmealorama_RecipeScaler$__scaleIngredient__Lmealorama_Ingredient__s_math_BigDecimal__Lmealorama_Ingredient as $p_Lmealorama_RecipeScaler$__scaleIngredient__Lmealorama_Ingredient__s_math_BigDecimal__Lmealorama_Ingredient };
function $p_Lmealorama_RecipeScaler$__normalize__s_math_BigDecimal__s_Option__T2($thiz, amount, unit) {
  if (unit.b()) {
    var x168 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = unit.i();
    var x168 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_LcookingSquants_package$().aaF(x0);
  }
  if (($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() === x168)) {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2($p_Lmealorama_RecipeScaler$__round__s_math_BigDecimal__s_math_BigDecimal($thiz, amount), unit);
  }
  if ((x168 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var uom = x168.aE;
    var qty = uom.fU(amount.bf.i2(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_Numeric$DoubleIsFractional$());
    var x165 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_LcookingSquants_CookingUnitGroup$().b40().l9(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$2) => {
      var x$1 = _$6$2.mZ();
      var x$2 = qty.mZ();
      return ((x$1 === null) ? (x$2 === null) : $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsquants_Dimension__equals__O__Z(x$1, x$2));
    })));
    if (($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() === x165)) {
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2($p_Lmealorama_RecipeScaler$__round__s_math_BigDecimal__s_math_BigDecimal($thiz, amount), unit);
    }
    if ((x165 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var group = x165.aE;
      var best = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_LcookingSquants_CookingUnitGroup__inBestUnit__Lsquants_Quantity__Lsquants_Quantity(group, qty);
      var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_package$().e8();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2($p_Lmealorama_RecipeScaler$__round__s_math_BigDecimal__s_math_BigDecimal($thiz, this$4.HT(best.pG(), this$4.bO)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(best.oi().gO()));
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x165);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x168);
}
export { $p_Lmealorama_RecipeScaler$__normalize__s_math_BigDecimal__s_Option__T2 as $p_Lmealorama_RecipeScaler$__normalize__s_math_BigDecimal__s_Option__T2 };
function $p_Lmealorama_RecipeScaler$__convertTo__s_math_BigDecimal__s_Option__T__s_Option($thiz, amount, fromUnit, toUnit) {
  if (fromUnit.b()) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = fromUnit.i();
    var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_LcookingSquants_package$().aaF(x0);
  }
  var this$1 = $x_1;
  if (this$1.b()) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0$1 = this$1.i();
    var this$2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_LcookingSquants_package$().aaF(toUnit);
    if (this$2.b()) {
      var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0$2 = this$2.i();
      var $x_2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T3(x0$2, x0$1.fU(amount.bf.i2(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_Numeric$DoubleIsFractional$()), x0$2.fU(1.0, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_Numeric$DoubleIsFractional$())));
    }
    var this$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Option$WithFilter($x_2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      var x173 = x$1$2.kb;
      var x174 = x$1$2.g7;
      if ((x173 !== null)) {
        if ((x174 !== null)) {
          var x = x173.mZ();
          var x$2 = x174.mZ();
          return ((x === null) ? (x$2 === null) : $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsquants_Dimension__equals__O__Z(x, x$2));
        }
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
    })));
    var this$8 = this$7.a00;
    var p$1 = this$7.a01;
    var this$9 = ((this$8.b() || (!(!p$1.d(this$8.i())))) ? this$8 : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
    if (this$9.b()) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0$3 = this$9.i();
      matchResult43: {
        var $x_3;
        var x179 = x0$3.kb;
        var x180 = x0$3.g7;
        var to$1 = x0$3.gz;
        if ((x179 !== null)) {
          if ((x180 !== null)) {
            var converted = x179.a2O(to$1);
            var this$10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_package$().e8();
            var $x_3 = $p_Lmealorama_RecipeScaler$__round__s_math_BigDecimal__s_math_BigDecimal($thiz, this$10.HT(converted.pG(), this$10.bO));
            break matchResult43;
          }
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x0$3);
      }
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($x_3);
    }
  }
}
export { $p_Lmealorama_RecipeScaler$__convertTo__s_math_BigDecimal__s_Option__T__s_Option as $p_Lmealorama_RecipeScaler$__convertTo__s_math_BigDecimal__s_Option__T__s_Option };
function $p_Lmealorama_RecipeScaler$__round__s_math_BigDecimal__s_math_BigDecimal($thiz, value) {
  var x$proxy1 = value.aHi(3, ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_package$().e8(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_BigDecimal$RoundingMode$()).a8t).bf.X8();
  if ((x$proxy1 === null)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Scala3RunTime$().S();
  }
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_math_BigDecimal(x$proxy1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_package$().e8().bO);
}
export { $p_Lmealorama_RecipeScaler$__round__s_math_BigDecimal__s_math_BigDecimal as $p_Lmealorama_RecipeScaler$__round__s_math_BigDecimal__s_math_BigDecimal };
/** @constructor */
function $c_Lmealorama_RecipeScaler$() {
  this.aK2 = 0;
  this.aK2 = 3;
}
export { $c_Lmealorama_RecipeScaler$ as $c_Lmealorama_RecipeScaler$ };
$p = $c_Lmealorama_RecipeScaler$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_RecipeScaler$;
/** @constructor */
function $h_Lmealorama_RecipeScaler$() {
}
export { $h_Lmealorama_RecipeScaler$ as $h_Lmealorama_RecipeScaler$ };
$h_Lmealorama_RecipeScaler$.prototype = $p;
$p.b19 = (function(recipe, targetServings) {
  var this$1 = recipe.ci;
  if (this$1.b()) {
    var $x_1 = true;
  } else {
    var $x_2 = this$1.i();
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_BigDecimal$();
    var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordered__$greater__O__Z($x_2, this$2.dG(0, this$2.bO));
  }
  if ($x_1) {
    var from = this$1;
  } else {
    var from = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  var x146 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(from, targetServings);
  var x157 = x146.rr;
  var x158 = (x146.rs | 0);
  if ((x158 <= 0)) {
    var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_BigDecimal$();
    return new $j_mealorama$002e$002dScaled$002dRecipe.$c_Lmealorama_ScaledRecipe(recipe, false, this$4.dG(1, this$4.bO), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_mealorama$002e$002dNot$002dScaled$002dReason$0024.$s_Lmealorama_NotScaledReason$__InvalidTargetServings__Lmealorama_NotScaledReason()));
  }
  if (($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() === x157)) {
    var this$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_BigDecimal$();
    return new $j_mealorama$002e$002dScaled$002dRecipe.$c_Lmealorama_ScaledRecipe(recipe, false, this$7.dG(1, this$7.bO), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_mealorama$002e$002dNot$002dScaled$002dReason$0024.$s_Lmealorama_NotScaledReason$__NoServingCount__Lmealorama_NotScaledReason()));
  }
  if ((x157 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var x154 = x157.aE;
    var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$();
    var this$10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_package$().e8();
    if ($x_3.vv(x154, this$10.dG(x158, this$10.bO))) {
      var this$11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_BigDecimal$();
      return new $j_mealorama$002e$002dScaled$002dRecipe.$c_Lmealorama_ScaledRecipe(recipe, false, this$11.dG(1, this$11.bO), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_mealorama$002e$002dNot$002dScaled$002dReason$0024.$s_Lmealorama_NotScaledReason$__AlreadyThatSize__Lmealorama_NotScaledReason()));
    }
    var this$14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_package$().e8();
    var factor$3 = this$14.dG(x158, this$14.bO).VF(x154);
    var this$16 = recipe.cn;
    var f = ((_$2$2) => $p_Lmealorama_RecipeScaler$__scaleIngredient__Lmealorama_Ingredient__s_math_BigDecimal__Lmealorama_Ingredient(this, _$2$2, factor$3));
    if ((this$16 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
      var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    } else {
      var x0$1 = this$16.e();
      var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      var t = h;
      var rest = this$16.c();
      while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
        var x0$2 = rest.e();
        var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$2), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        t.t = nx;
        t = nx;
        rest = rest.c();
      }
      var $x_4 = h;
    }
    var scaledIngredients = $x_4;
    var this$17 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_package$().e8();
    var servings$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(this$17.dG(x158, this$17.bO));
    var $x_7 = recipe;
    var $x_6_$_lo = $x_7.c9;
    var $x_6_$_hi = $x_7.ca;
    var $x_5 = recipe;
    return new $j_mealorama$002e$002dScaled$002dRecipe.$c_Lmealorama_ScaledRecipe(new $j_mealorama$002e$002dRecipe.$c_Lmealorama_Recipe($x_6_$_lo, $x_6_$_hi, $x_5.dy, $x_5.dz, recipe.bL, recipe.cO, recipe.d7, recipe.cG, recipe.d8, recipe.dh, recipe.cj, recipe.cW, recipe.cT, servings$1, recipe.cy, recipe.cX, recipe.dg, recipe.ds, scaledIngredients, recipe.cF, recipe.cU, recipe.cN, recipe.dr, recipe.dt, recipe.di, recipe.cV, recipe.dj), true, factor$3, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x146);
});
$p.b1a = (function(recipe, factor) {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_BigDecimal$();
  if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordered__$less$eq__O__Z(factor, this$1.dG(0, this$1.bO))) {
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_BigDecimal$();
    return new $j_mealorama$002e$002dScaled$002dRecipe.$c_Lmealorama_ScaledRecipe(recipe, false, this$2.dG(1, this$2.bO), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_mealorama$002e$002dNot$002dScaled$002dReason$0024.$s_Lmealorama_NotScaledReason$__InvalidTargetServings__Lmealorama_NotScaledReason()));
  } else {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$();
    var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_package$().e8();
    if ($x_1.vv(factor, this$5.dG(1, this$5.bO))) {
      var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_BigDecimal$();
      return new $j_mealorama$002e$002dScaled$002dRecipe.$c_Lmealorama_ScaledRecipe(recipe, false, this$6.dG(1, this$6.bO), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_mealorama$002e$002dNot$002dScaled$002dReason$0024.$s_Lmealorama_NotScaledReason$__AlreadyThatSize__Lmealorama_NotScaledReason()));
    } else {
      var this$9 = recipe.ci;
      var servings$2 = (this$9.b() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(this$9.i().HC(factor)));
      var this$11 = recipe.cy;
      var yields$2 = (this$11.b() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(this$11.i().HC(factor)));
      var this$14 = recipe.cn;
      var f = ((_$5$2) => $p_Lmealorama_RecipeScaler$__scaleIngredient__Lmealorama_Ingredient__s_math_BigDecimal__Lmealorama_Ingredient(this, _$5$2, factor));
      if ((this$14 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
        var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      } else {
        var x0$2 = this$14.e();
        var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$2), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        var t = h;
        var rest = this$14.c();
        while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
          var x0$3 = rest.e();
          var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$3), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
          t.t = nx;
          t = nx;
          rest = rest.c();
        }
        var $x_2 = h;
      }
      var ingredients$1 = $x_2;
      var $x_5 = recipe;
      var $x_4_$_lo = $x_5.c9;
      var $x_4_$_hi = $x_5.ca;
      var $x_3 = recipe;
      return new $j_mealorama$002e$002dScaled$002dRecipe.$c_Lmealorama_ScaledRecipe(new $j_mealorama$002e$002dRecipe.$c_Lmealorama_Recipe($x_4_$_lo, $x_4_$_hi, $x_3.dy, $x_3.dz, recipe.bL, recipe.cO, recipe.d7, recipe.cG, recipe.d8, recipe.dh, recipe.cj, recipe.cW, recipe.cT, servings$2, yields$2, recipe.cX, recipe.dg, recipe.ds, ingredients$1, recipe.cF, recipe.cU, recipe.cN, recipe.dr, recipe.dt, recipe.di, recipe.cV, recipe.dj), true, factor, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
    }
  }
});
var $d_Lmealorama_RecipeScaler$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_RecipeScaler$, "mealorama.RecipeScaler$", ({
  GM: 1
}));
export { $d_Lmealorama_RecipeScaler$ as $d_Lmealorama_RecipeScaler$ };
var $n_Lmealorama_RecipeScaler$;
function $m_Lmealorama_RecipeScaler$() {
  if ((!$n_Lmealorama_RecipeScaler$)) {
    $n_Lmealorama_RecipeScaler$ = new $c_Lmealorama_RecipeScaler$();
  }
  return $n_Lmealorama_RecipeScaler$;
}
export { $m_Lmealorama_RecipeScaler$ as $m_Lmealorama_RecipeScaler$ };
//# sourceMappingURL=mealorama.-Recipe-Scaler$.js.map
